import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {IconButton, Snackbar} from "@material-ui/core";

export const TOP_RIGHT_POSITION = {
    vertical: 'top',
    horizontal: 'right',
};

export const TOP_LEFT_POSITION = {
    vertical: 'top',
    horizontal: 'left',
};

export const TOP_CENTER_POSITION = {
    vertical: 'top',
    horizontal: 'center',
};

export const BOTTOM_RIGHT_POSITION = {
    vertical: 'bottom',
    horizontal: 'right',
};

export const BOTTOM_LEFT_POSITION = {
    vertical: 'bottom',
    horizontal: 'left',
};

export const BOTTOM_CENTER_POSITION = {
    vertical: 'bottom',
    horizontal: 'center',
};

export const DEFAULT_TYPE = 'default';
export const SUCCESS_TYPE = 'success';
export const ERROR_TYPE = 'error';

const Notification = ({classes, className, children, position, type, ActionButton, ...rest}) => (
    <Snackbar
        className={cn(classes.notification, className, type, 'notification')}
        anchorOrigin={position}
        message={children}
        action={[ActionButton,]}
        {...rest}
    />
);

Notification.defaultProps = {
    position: TOP_RIGHT_POSITION,
    autoHideDuration: 3000,
    type: DEFAULT_TYPE,
};

Notification.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    open: PropTypes.bool,
    position: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string,
    }),
    ActionButton: PropTypes.element,
    onClose: PropTypes.func,
    type: PropTypes.oneOf(['default', 'success', 'error'])
};

export const NActionButton = ({className, onClick, ariaLabel, ...rest}) => (
    <IconButton
        aria-label={ariaLabel}
        color="inherit"
        className={cn('actionButton', className)}
        onClick={onClick} {...rest}/>);

NActionButton.propTypes = {
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
};

export default Notification;
